

export const AppVariables = {
  apiBaseUrl: 'https://test.junoaudit.pl',
  authApiBaseUrl: '/api/auth',
  environmentName: 'QA'
};
